import { State } from '../../main/reducers/rootReducer';
import { createSelector } from 'reselect';

const getBusinessUnitState = ((state: State) => state.businessUnits);

export const getBusinessUnits = createSelector([getBusinessUnitState], s => s.businessUnits);